import { FC } from 'react';
import { useField } from 'informed';
import { SuccessIcon } from '@assets/svg';
import { IDropdownOption, InformedFieldState } from '@common/interfaces';
import css from './styles.module.scss';

interface ICheckOptionField {
  name: string;
  options: IDropdownOption[];
}

const CheckOptionField: FC<ICheckOptionField> = (props) => {
  const { options, name } = props;

  const { fieldState, fieldApi, render, ref } = useField(props);

  const { value: fieldValue = [], error, showError } = fieldState as InformedFieldState<IDropdownOption[]>;

  const { setValue, setTouched } = fieldApi;

  const toggleValue = (option: IDropdownOption, e: React.ChangeEvent<HTMLInputElement>) => {
    const exists = fieldValue.some((v) => v.value === option.value);

    const nextValue = exists ? fieldValue.filter((v) => v.value !== option.value) : [...fieldValue, option];

    setValue(nextValue);
    setTouched(true, e);
  };

  return render(
    <div ref={ref} className={css.wrapper}>
      {options.map(({ value, label }, idx) => {
        const isChecked = fieldValue.some((v) => v.value === value);
        const id = `${name}-${value}`;

        return (
          <label htmlFor={id} key={idx} className={css.field}>
            <input
              className={css.input}
              type='checkbox'
              id={id}
              name={name}
              checked={isChecked}
              onChange={(e) => toggleValue({ value, label }, e)}
            />
            <div className={css.item}>
              {label}
              <SuccessIcon />
            </div>
          </label>
        );
      })}
      {showError ? <div className={css.error}>{error}</div> : null}
    </div>
  );
};

export default CheckOptionField;
